import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { singularize, toCamelCase, toPascalCase } from '@cli-utils/text.js'

export function getSingleM2MContext(schemaName: string, field: SchemaField) {
  const singularSchema = singularize(schemaName)
  const relationship = field.relationship ?? ''
  const relationshipSingular = singularize(relationship)

  return {
    junctionVar: toCamelCase(`${singularSchema}${toPascalCase(relationship)}`),
    schemaIdCol: `${singularSchema}Id`,
    relationIdCol: `${relationshipSingular}Id`,
    relationIdVar: `${relationshipSingular}Id`,
    inputIdsVar: `${field.name}Ids`
  }
}
